// src/App.tsx
import { AppShell, Text, Group } from '@mantine/core';
import "./App.css";
import { Route, Switch } from 'wouter';
import { EntryPage } from './pages/EntryPage';
import Dashboard from './pages/dashboard';
import { HeaderSimple } from './header';
import PrivateRoute from '@/componets/private.route.tsx';
import AboutPage from './pages/AboutPage';
import SupportPage from './pages/SupportPage';
import { getAppVersion } from '@/utils/version.fn';
import StatusPage from './pages/StatusPage';

function App() {
  return (
    <>
      <AppShell header={{ height: 56, offset: true }}>
        <AppShell.Header>
          <HeaderSimple />
        </AppShell.Header>
        <AppShell.Main style={{ minHeight: 'calc(100vh - 64px)' }}>
          <Switch>
            <Route path="/login" component={EntryPage} />
            <Route path="/status" component={StatusPage} />
            <PrivateRoute path="/dashboard" component={Dashboard} />
            <PrivateRoute path="/support" component={SupportPage} />
            <Route component={AboutPage} />
          </Switch>
        </AppShell.Main>
        <AppShell.Footer>
            <Group grow ta="start">
              <Text c="dimmed" size="xs" pr="md">
                Version: {getAppVersion()}
              </Text>
            </Group>
        </AppShell.Footer>
      </AppShell>
    </>
  );
}

export default App;
